export default {
    nav: $('.mobile-menu'),
    menuToggle: $('.menu-toggle'),
    itemsWithChildren: $('.has-children'),
    menuBack: $('.menu-back'),
    menuIsOpen: false,
    languageSwitcher: $('.language-dropdown'),

    init: function () {
        this.bindEvents();
    },

    toggle: function () {
        this.nav.toggleClass('visible');
        this.menuToggle.toggleClass('open');
        this.menuIsOpen = !(this.menuIsOpen);
        $('body').toggleClass('mobile-menu-open');
        $('.menu-back').removeClass('visible');
        $('.mobile-menu-cta').removeClass('visible');
    },

    menuSwap: function ($$) {
        let clickedID = $$.data('id');
        $('.menu-back').addClass('visible');
        $('.mobile-nav-wrap').find('#menu-' + clickedID).addClass('visible');

    },

    toggleCta: function () {
        $('.mobile-menu-cta').addClass('visible');
    },

    menuCloseLayer: function () {
        $('.menu').find('.visible').removeClass('visible');
        $('.mobile-menu-cta').removeClass('visible');
    },

    bindEvents: function () {

        let _this = this;

        this.menuToggle.on('click', () => {
            _this.toggle();

            if (!_this.menuIsOpen) {
                $('.mobile-nav-wrap').find('.menu').removeClass('visible');
            }

        });

        this.itemsWithChildren.on('click', function (e) {
            e.preventDefault();
            _this.menuSwap($(this));
            _this.toggleCta($(this));
        });

        this.menuBack.on('click', function () {
            $('.menu').removeClass('visible');
            $('.menu-back').removeClass('visible');
            $('.mobile-menu-cta').removeClass('visible');
        });
        this.languageSwitcher.on('click', function () {
            $(this).toggleClass('visible');
        });
        // if (window.innerWidth < 1026) {
        //
        // }
    },
};